import allVehiclesRoutes from '../../vehicles/allVehiclesRoutes';
import myVehiclesRoutes from '../../vehicles/myVehiclesRoutes';
import accessRightsRoutes from '../../accessRights/routes';
import onPremiseAccessRightsRoutes from '../../onPremiseAccessRights/routes';

const routes = [
  {
    title: 'Home',
    icon: 'home',
    id: 'default',
    routes: [
      ...myVehiclesRoutes,
      ...onPremiseAccessRightsRoutes,
      ...allVehiclesRoutes,
      ...accessRightsRoutes,
    ],
  },
];

export default routes;
